import { callWithNuxt } from '#app'
import NuxtApollo from '#build/apollo'

export function useGetToken() {
    const nuxtApp = useNuxtApp()

    const getToken = async (client?: string) => {
        client = client || 'default'
        const conf = NuxtApollo?.clients?.[client]
        const token = ref<string | null>(null)
        await (nuxtApp as ReturnType<typeof useNuxtApp>).callHook('apollo:auth', { token, client })
        if (token.value) {
            return token.value
        }

        const tokenName = conf.tokenName!

        return conf?.tokenStorage === 'cookie'
            ? callWithNuxt(nuxtApp as ReturnType<typeof useNuxtApp>, () => useCookie(tokenName).value)
            : (process.client && localStorage.getItem(tokenName)) || null
    }

    return {
        getToken,
    }
}
